import { SET_USER_INFO } from "../../actions/DashboardDesigner/actionContants";

const userInfo = (state = [], action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type:
		 *  userInfo:
		 * }
		 */
		case SET_USER_INFO:
			return { ...state, ...action.userInfo };
		default:
			return state;
	}
};

export default userInfo;
